<template>
  <div class="c-details-image-cover">
    <v-detail-product-image
      v-show="!showSkinAd"
      :product="product"
      :type="ImageType.COVER"
      :background-only="backgroundOnly"
      class="c-details-image-cover__image"
    ></v-detail-product-image>
    <div
      v-if="!showSkinAd"
      class="c-details-image-cover__gradient"
    ></div>
  </div>
</template>

<script>
  import { VDetailProductImage } from '@/index/shared/components';
  import { ImageType } from '@/shared/enums';

  export default {
    components: {
      VDetailProductImage,
    },
    enums: {
      ImageType,
    },
    props: {
      showSkinAd: Boolean,
      product: Object,
      backgroundOnly: Boolean,
    },
  };
</script>
